// frontend/src/components/layout/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    // Added !bg-gray-900 to force dark background
    // Added w-full to ensure full width
    // Added relative z-10 to ensure it sits correctly in the stack
    <footer className="!bg-gray-900 text-white py-10 pb-24 md:pb-10 w-full relative z-10 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          
          {/* Column 1 */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">Everything Automotive</h3>
            <p className="text-gray-400 text-sm">
              Your trusted partner for parts, services, and vehicle sales in Nigeria.
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="font-bold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/parts" className="hover:text-white transition-colors">Shop Parts</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/verification" className="hover:text-white transition-colors">Business Verification</Link></li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="font-bold mb-4 text-white">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Registered business details - shown on every page for verification. */}
        <div className="border-t border-gray-800 pt-6 mb-6 text-sm text-gray-400">
          <p className="font-semibold text-gray-300 mb-1">ESEKIE DIGITAL SERVICES</p>
          <p>RC/BN: 9182646 &middot; Registered with the Corporate Affairs Commission (CAC), Nigeria</p>
          <p>NO. 2, HARRISON IDOKPA COMMUNITY, BENIN, EDO STATE, NIGERIA</p>
          <p>
            <Link to="/verification" className="text-blue-400 hover:text-blue-300 transition-colors">
              View business registration certificate
            </Link>
          </p>
        </div>

        <div className="border-t border-gray-800 pt-6 text-center text-sm text-gray-500">
          <p>&copy; {new Date().getFullYear()} Everything Automotive. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;